<template>
    <v-app>
        <v-container >
            <Features/>
        </v-container>
    </v-app>
</template>

<script>
    import Features from "../../components/Features";
    export default {
        name: 'dashboard-home',
        components: {Features},
        props: {},
        mounted() {
            scroll(0, 0);
        },
        data: () => ({})

    }

</script>
